import React, { Fragment, useEffect } from "react";
import { Pagina } from "./template/Template";
import { AuthContext } from "../App";
import { Button } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import ptBR2 from "date-fns/locale/pt-BR";
// import { grey } from "@material-ui/core/colors";
import HourglassEmptyRoundedIcon from "@material-ui/icons/HourglassEmptyRounded";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  findPendentes,
  findInconsistentes,
  findAprovados,
  findSuspeitos,
} from "../services/ContainerService";
import { format } from "date-fns";
//import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Loading } from "./Loading";
import { ShowMessageBox } from "./ShowMessageBox";

let severity = "error";
let msg = "";

export default function Dashboard() {
  const { state: authState } = React.useContext(AuthContext);

  const useStyles = makeStyles((theme) => ({
    dashboard: {
      width: "80vw",
      margin: "0 auto",
      height: "70vh",
    },

    container: {
      display: "flex",
      width: "80vw",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto",
    },
    dashboard_header: {
      display: "flex",
      width: "100%",

      justifyContent: "space-evenly",
      backgroundColor: "#AED6F1",
      color: "",
      paddingLeft: "5px",
      paddingRight: "5px",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
    },

    dashboard_header_status: {
      display: "flex",
      flexDirection: "column",
    },

    dashboard_header_filtro: {
      display: "flex",
      "flex-direction": "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
    dashboard_header_filtro_1: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      flexGrow: 1,
      alignSelf: "flex-end",
    },
    dashboard_content: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-evenly",

      alignItems: "center",
      marginTop: "1rem",
      gap: "2px",
    },
    fabMicro: {
      height: 20,
      width: 20,
    },
    dashboard_content_aprovado: {
      display: "flex",
      flexDirection: "column",
      border: "2px solid #43b100",
      width: "20vw",
      height: "65vh",
    },
    dashboard_content_aprovado_header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "45px",
      fontSize: "150%",
      color: "#43b100",
    },
    dashboard_content_aprovado_content: {
      width: "100%",
      height: "100%",
      overflow: "auto",
    },
    dashboard_content_inconsistente: {
      display: "flex",
      flexDirection: "column",
      border: "2px solid #dbd704",
      width: "20vw",
      height: "65vh",
    },
    dashboard_content_inconsistente_header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "45px",
      fontSize: "150%",
      color: "#dbd704",
    },
    dashboard_content_inconsistente_content: {
      width: "100%",
      height: "100%",
      overflow: "auto",
    },
    dashboard_content_suspeito: {
      display: "flex",
      flexDirection: "column",
      border: "2px solid #da0203",
      width: "20vw",
      height: "65vh",
    },
    dashboard_content_suspeito_header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "45px",
      fontSize: "150%",
      color: "#da0203",
    },
    dashboard_content_suspeito_content: {
      width: "100%",
      height: "100%",
      overflow: "auto",
    },
    dashboard_content_pendente: {
      display: "flex",
      flexDirection: "column",
      border: "2px solid #348cf8",
      width: "20vw",
      height: "65vh",
    },
    dashboard_content_pendente_header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "45px",
      fontSize: "150%",
      color: "#348cf8",
    },
    dashboard_content_pendente_content: {
      width: "100%",
      height: "100%",
      overflow: "auto",
    },

    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

  const ButtonRound = withStyles((theme) => ({
    root: {
      color: "white",
      fontSize: "60%",
      padding: "5px",
      margin: "4px 2px",
      width: "10px",
      backgroundColor: "#3f51b5",
      "&:hover": {
        backgroundColor: "fFFD580",
      },
    },
  }))(Button);

  var MS_PER_MINUTE = 60000;
  var MS_PER_DAY = 60000 * 60 * 24;

  const Content = () => {
    const classes = useStyles();
    const [rowsPendentes, setRowsPendentes] = React.useState([]);
    const [rowsInconsistentes, setRowsInconsistentes] = React.useState([]);
    const [rowsAprovados, setRowsAprovados] = React.useState([]);
    const [rowsSuspeitos, setRowsSuspeitos] = React.useState([]);

    const [pendentes, setPendentes] = React.useState(0);
    const [inconsistentes, setInconsistentes] = React.useState(0);
    const [aprovados, setAprovados] = React.useState(0);
    const [suspeitos, setSuspeitos] = React.useState(0);

    const [selectedDataInicial, setSelectedDataInicial] = React.useState();
    const [selectedDataFinal, setSelectedDataFinal] = React.useState();

    const [openLoading, setOpenLoading] = React.useState(false);
    const [openSnackBar, setOpenSnackBar] = React.useState(false);

    const handleDataInicialChange = (date) => {
      setSelectedDataInicial(date);
    };
    const handleDataFinalChange = (date) => {
      setSelectedDataFinal(date);
    };

    useEffect(async () => {
      let dtf = new Date();
      let dti = new Date(dtf.getTime() - 1 * MS_PER_DAY);

      let dtif = format(dti, "yyyy-MM-dd'T'HH:mm:ss");
      let dtff = format(dtf, "yyyy-MM-dd'T'HH:mm:ss");

      setSelectedDataFinal(dtf);
      setSelectedDataInicial(dti);

      setOpenSnackBar(false);
      setOpenLoading(true);

      try {
        const respPendentes = await findPendentes(authState.id, dtif, dtff);
        setRowsPendentes(respPendentes.data);
        setPendentes(respPendentes.data.length);

        const respInconsistente = await findInconsistentes(
          authState.id,
          dtif,
          dtff
        );
        setRowsInconsistentes(respInconsistente.data);
        setInconsistentes(respInconsistente.data.length);

        const respSuspeitos = await findSuspeitos(authState.id, dtif, dtff);
        setRowsSuspeitos(respSuspeitos.data);
        setSuspeitos(respSuspeitos.data.length);

        const respAprovados = await findAprovados(authState.id, dtif, dtff);
        setRowsAprovados(respAprovados.data);
        setAprovados(respAprovados.data.length);
      } catch (error) {
        msg = `Erro na carga dos dados ${error.message}`;
        severity = "error";
        setOpenSnackBar(true);
      } finally {
        setOpenLoading(false);
      }
      //    return () => mounted = false;
    }, []);

    const reloadData = async () => {
      let dti = selectedDataInicial;
      let dtf = selectedDataFinal;

      let dtif = format(dti, "yyyy-MM-dd'T'HH:mm:ss");
      let dtff = format(dtf, "yyyy-MM-dd'T'HH:mm:ss");

      setOpenSnackBar(false);
      setOpenLoading(true);

      try {
        const respPendentes = await findPendentes(authState.id, dtif, dtff);
        setRowsPendentes(respPendentes.data);
        setPendentes(respPendentes.data.length);

        const respInconsistente = await findInconsistentes(
          authState.id,
          dtif,
          dtff
        );
        setRowsInconsistentes(respInconsistente.data);
        setInconsistentes(respInconsistente.data.length);

        const respSuspeitos = await findSuspeitos(authState.id, dtif, dtff);
        setRowsSuspeitos(respSuspeitos.data);
        setSuspeitos(respSuspeitos.data.length);

        const respAprovados = await findAprovados(authState.id, dtif, dtff);
        setRowsAprovados(respAprovados.data);
        setAprovados(respAprovados.data.length);
      } catch (error) {
        msg = `Erro na carga dos dados ${error.message}`;
        severity = "error";
        setOpenSnackBar(true);
      } finally {
        setOpenLoading(false);
      }
    };

    const reloadDataMinuto = async (minutos) => {
      let dtf = new Date();
      let dti = new Date(dtf.getTime() - minutos * MS_PER_MINUTE);

      let dtif = format(dti, "yyyy-MM-dd'T'HH:mm:ss");
      let dtff = format(dtf, "yyyy-MM-dd'T'HH:mm:ss");

      setOpenSnackBar(false);
      setOpenLoading(true);

      try {
        const respPendentes = await findPendentes(authState.id, dtif, dtff);
        setRowsPendentes(respPendentes.data);
        setPendentes(respPendentes.data.length);

        const respInconsistente = await findInconsistentes(
          authState.id,
          dtif,
          dtff
        );
        setRowsInconsistentes(respInconsistente.data);
        setInconsistentes(respInconsistente.data.length);

        const respSuspeitos = await findSuspeitos(authState.id, dtif, dtff);
        setRowsSuspeitos(respSuspeitos.data);
        setSuspeitos(respSuspeitos.data.length);

        const respAprovados = await findAprovados(authState.id, dtif, dtff);
        setRowsAprovados(respAprovados.data);
        setAprovados(respAprovados.data.length);
      } catch (error) {
        msg = `Erro na carga dos dados ${error.message}`;
        severity = "error";
        setOpenSnackBar(true);
      } finally {
        setOpenLoading(false);
      }
    };

    return (
      <Fragment>
        <div className={classes.container}>
          <div className={classes.dashboard}>
            <div className={classes.dashboard_header}>
              <div className={classes.dashboard_header_status}>
                <div className={classes.dashboard_header_filtro_1}>
                  <HourglassEmptyRoundedIcon />
                  <span
                    style={{
                      fontSize: "110%",
                      color: "#3f51b5",
                      fontWeight: "bold",
                    }}
                  ></span>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(15)}
                  >
                    15 min
                  </ButtonRound>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(30)}
                  >
                    30 min
                  </ButtonRound>
                  <ButtonRound onClick={() => reloadDataMinuto(60)}>
                    1 hora
                  </ButtonRound>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(120)}
                  >
                    2 horas
                  </ButtonRound>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(360)}
                  >
                    6 horas
                  </ButtonRound>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(720)}
                  >
                    12 horas
                  </ButtonRound>
                  <ButtonRound
                    style={{ fontWeight: "bold" }}
                    onClick={() => reloadDataMinuto(1440)}
                  >
                    1 dia
                  </ButtonRound>
                </div>
              </div>
              <div className={classes.dashboard_header_filtro}>
                <MuiPickersUtilsProvider locale={ptBR2} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-inicial"
                    label="Inicio"
                    format="dd/MM/yyyy"
                    value={selectedDataInicial}
                    onChange={handleDataInicialChange}
                    style={{ width: "150px", marginRight: "30px" }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>

                <MuiPickersUtilsProvider locale={ptBR2} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-termino"
                    label="Termino"
                    format="dd/MM/yyyy"
                    value={selectedDataFinal}
                    style={{ width: "150px", marginRight: "30px" }}
                    onChange={handleDataFinalChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={reloadData}
                >
                  Filtrar
                </Button>
              </div>
            </div>
            <div className={classes.dashboard_content}>
              <Loading open={openLoading} />
              <ShowMessageBox
                open={openSnackBar}
                setOpen={setOpenSnackBar}
                severity={severity}
                msg={msg}
              />
              <div className={classes.dashboard_content_aprovado}>
                <div className={classes.dashboard_content_aprovado_header}>
                  Aprovado: <b>{aprovados}</b>
                </div>
                <div className={classes.dashboard_content_aprovado_content}>
                  {rowsAprovados.map((aprov) => (
                    <ListItem key={`${aprov.id}`}>
                      <ListItemText primary={`${aprov.con_container}`} />
                    </ListItem>
                  ))}
                </div>
              </div>

              <div className={classes.dashboard_content_inconsistente}>
                <div className={classes.dashboard_content_inconsistente_header}>
                  Inconsistente: <b> {inconsistentes} </b>
                </div>
                <div
                  className={classes.dashboard_content_inconsistente_content}
                >
                  {rowsInconsistentes.map((inc) => (
                    <ListItem key={`${inc.id}`}>
                      <ListItemText primary={`${inc.con_container}`} />
                    </ListItem>
                  ))}
                </div>
              </div>

              <div className={classes.dashboard_content_suspeito}>
                <div className={classes.dashboard_content_suspeito_header}>
                  Suspeito: <b>{suspeitos}</b>
                </div>
                <div className={classes.dashboard_content_suspeito_content}>
                  {rowsSuspeitos.map((susp) => (
                    <ListItem key={`${susp.id}`}>
                      <ListItemText primary={`${susp.con_container}`} />
                    </ListItem>
                  ))}
                </div>
              </div>

              <div className={classes.dashboard_content_pendente}>
                <div className={classes.dashboard_content_pendente_header}>
                  Pendente: <b>{pendentes}</b>
                </div>
                <div className={classes.dashboard_content_pendente_content}>
                  {rowsPendentes.map((pend) => (
                    <ListItem key={`${pend.id}`}>
                      <ListItemText primary={`${pend.con_container}`} />
                    </ListItem>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Pagina authState={authState} Content={Content} HeaderDesc="DASHBOARD" />
    </Fragment>
  );
}
